module.exports = __webpack_public_path__ + "img/SB_logo.1173b804.png";